import { inject, Injectable } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { SwUpdate, VersionEvent } from '@angular/service-worker';

import { filter, switchMap, tap } from 'rxjs/operators';

@Injectable()
export class ApplicationVersionService {
  private router = inject(Router);
  private updates = inject(SwUpdate);

  init(): void {
    this.listenToAvailableUpdate();
    this.checkForUpdate();
  }

  private listenToAvailableUpdate(): void {
    this.updates.versionUpdates
      .pipe(
        filter((event: VersionEvent) => event.type === 'VERSION_READY'),
        tap(update => console.log('update available', update)),
        switchMap(() => this.updates.activateUpdate()),
        tap(() => window.location.reload())
      )
      .subscribe();
  }

  private checkForUpdate(): void {
    this.router.events
      .pipe(
        filter((event: Event) => event instanceof NavigationEnd),
        filter(() => this.updates.isEnabled),
        tap(() => {
          this.updates.checkForUpdate().catch(err => console.error('Failed to check for updates:', err));
        })
      )
      .subscribe();
  }
}
